import { ApiResponse } from 'apisauce'
import { api } from './_http'

const Languages = {
  getList: (component?: 'website'): Promise<ApiResponse<Array<ABTypes.Monolith.Locale>>> => api.get(`/msvc/v1/pages/locales${component ? `?component=${component}` : ''}`)
}

export default Languages
